"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6605,8461,2968],{

/***/ 98461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FullParagraphComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.scss.js



var StyledFullParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej9vftf0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.full-paragraph-wrapper{max-width:1100px;margin:auto;display:flex;justify-content:center;padding:0px ", full_paragraph/* PARAGRAPH_HORIZONTAL_PADDING_STRING */.xe, ";}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FullParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullParagraphComponent);
    function FullParagraphComponent() {
        (0,_class_call_check/* default */.Z)(this, FullParagraphComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FullParagraphComponent, [
        {
            key: "render",
            value: function render() {
                var maxWidth = this.props.maxWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFullParagraphComponent, {
                    className: "full-paragraph-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "full-paragraph-wrapper",
                        style: {
                            maxWidth: maxWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return FullParagraphComponent;
}(react.PureComponent);

FullParagraphComponent.defaultProps = _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.MD,
    textSize: sizes.MD,
    maxWidth: "1100px"
});


/***/ }),

/***/ 76605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ paragraph_and_carousel_reviews_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js + 1 modules
var two_thirds_text_and_asset_component = __webpack_require__(32968);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/services/hooks/use-interval.js
var use_interval = __webpack_require__(32184);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/customer-quotes.js
var customer_quotes = __webpack_require__(64265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews-carousel/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ var default_props = ({
    autoplay: {
        shouldAutoPlay: true,
        interval: "10000"
    },
    reviews: [
        _object_spread_props(_object_spread({}, customer_quotes/* default */.ZP[customer_quotes/* CUSTOMER_KEY_OSCAR */.Nz]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/oscar_image.png",
                alt: "Oscar's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/oscar_logo.svg",
                alt: "Oscar logo"
            }
        }),
        _object_spread_props(_object_spread({}, customer_quotes/* default */.ZP[customer_quotes/* CUSTOMER_KEY_THE_STUDENT_HOTEL */.iV]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/the_student_hotel_image.png",
                alt: "The Student Hotel's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/the_student_hotel_logo.svg",
                alt: "The Student Hotel logo"
            }
        }),
        _object_spread_props(_object_spread({}, customer_quotes/* default */.ZP[customer_quotes/* CUSTOMER_KEY_TELEFONICA */.tx]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/telefonica_image.png",
                alt: "Telefonica's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/telefonica_logo.svg",
                alt: "Telefonica logo"
            }
        }),
        _object_spread_props(_object_spread({}, customer_quotes/* default */.ZP[customer_quotes/* CUSTOMER_KEY_ZIPPO */.bd]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/zippo_image.png",
                alt: "Zippo's customer image"
            },
            companyLogo: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/zippo.svg",
                alt: "Zippo logo"
            }
        }),
        _object_spread_props(_object_spread({}, customer_quotes/* default */.ZP[customer_quotes/* CUSTOMER_KEY_NISSAN */.vK]), {
            customerImage: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/nissan_image.png",
                alt: "Nissan's customer image"
            },
            companyLogo: {}
        })
    ]
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews-carousel/reviews-carousel.scss.js



var CONTENT_PADDING = "44px";
var IMAGE_WIDTH = 200;
var INDICATORS_PADDING = 4.5;
var INDICATOR_SIZE = 11;
var INDICATOR_SIZE_ON_HOVER = 16;
var INDICATORS_PADDING_STRING = "".concat(INDICATORS_PADDING, "px");
var INDICATORS_PADDING_ON_HOVER_STRING = "".concat(INDICATORS_PADDING - (INDICATOR_SIZE_ON_HOVER - INDICATOR_SIZE) / 2, "px");
var INDICATOR_SIZE_STRING = "".concat(INDICATOR_SIZE, "px");
var INDICATOR_SIZE_ON_HOVER_STRING = "".concat(INDICATOR_SIZE_ON_HOVER, "px");
var background = "linear-gradient(180deg, ".concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], " 0%, ").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], " 25%, ").concat(colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], " 100%)");
var StyledReviewsCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18fuqgk0"
})(".reviews-carousel-content-and-indicators{margin-right:", IMAGE_WIDTH * 3 / 5, "px;&.has-customer-image{margin-bottom:", IMAGE_WIDTH - 100, "px;}.reviews-carousel-content{width:100%;height:320px;background:", background, ";border-radius:16px;color:white;justify-content:space-between;display:flex;flex-direction:column;padding:", CONTENT_PADDING, ";position:relative;.quote-wrapper{display:flex;flex-direction:row;font-size:1.3125rem;flex:1;opacity:0;transition:all 0.3s;&:not(:first-child){position:absolute;top:0;left:0;padding:", CONTENT_PADDING, ";height:100%;}&.selected{opacity:1;}.content-wrapper{display:flex;justify-content:space-between;flex-direction:column;transition:all 0.3s;.quote{position:relative;margin:auto 0;display:flex;text-align:left;letter-spacing:-0.5px;line-height:36px;.quotationMark{position:absolute;top:0;left:-8px;margin-right:8px;}}.footer{.name-and-job-description{font-size:0.875rem;}.logo{display:flex;padding-top:16px;height:38px;img{max-height:38px;}&.hidden{visibility:hidden;}}}}}}.indicators{display:flex;margin-top:24px;justify-content:center;align-items:center;height:", INDICATOR_SIZE_ON_HOVER_STRING, ";.indicator-wrapper{padding:", INDICATORS_PADDING_STRING, ";cursor:pointer;transition:padding 0.2s ease-in-out;.indicator{border:1px solid ", colors/* default.asphalt */.Z.asphalt, ";width:", INDICATOR_SIZE_STRING, ";height:", INDICATOR_SIZE_STRING, ";border-radius:8px;transition:width 0.2s ease-in-out,height 0.2s ease-in-out;&.selected{border:", "1px solid ".concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME]), ";background:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}&:hover{padding:", INDICATORS_PADDING_ON_HOVER_STRING, ";.indicator{width:", INDICATOR_SIZE_ON_HOVER_STRING, ";height:", INDICATOR_SIZE_ON_HOVER_STRING, ";}}&:hover:focus{outline:none;}}}}.reviews-carousel-asset{position:absolute;bottom:0;right:0;width:", IMAGE_WIDTH, "px;height:", IMAGE_WIDTH, "px;border-radius:16px;transition:opacity 0.2s ease-in-out;img{max-width:", IMAGE_WIDTH, "px;max-height:", IMAGE_WIDTH, "px;height:auto;width:auto;margin:0 auto;border-radius:16px;}&.hidden{visibility:hidden;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews-carousel/reviews-carousel.js
function reviews_carousel_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reviews_carousel_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reviews_carousel_define_property(target, key, source[key]);
        });
    }
    return target;
}
function reviews_carousel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reviews_carousel_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reviews_carousel_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var DEFAULT_AUTOPLAY_INTERVAL = 10000; // 10 seconds
var INDICATOR_WRAPPER_CLASS_NAME = "indicator-wrapper";
var ReviewsCarousel = function(props) {
    var _reviews_currentReviewIndex;
    var ref = (0,react.useState)(0), currentReviewIndex = ref[0], setCurrentReviewIndex = ref[1];
    var _autoplay = props.autoplay, shouldAutoPlay = _autoplay.shouldAutoPlay, interval = _autoplay.interval, reviews = props.reviews, removeQuoteSigns = props.removeQuoteSigns;
    (0,use_interval/* default */.Z)(function() {
        setCurrentReviewIndex((currentReviewIndex + 1) % reviews.length);
    }, shouldAutoPlay ? Number(interval) || DEFAULT_AUTOPLAY_INTERVAL : null, [
        currentReviewIndex
    ]);
    var selectReview = function(reviewIndex, e) {
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".".concat(INDICATOR_WRAPPER_CLASS_NAME))) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        setCurrentReviewIndex(reviewIndex);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_PAGE_CLICKED, {
            info1: reviewIndex
        });
    };
    var hasCustomerImage = function(review) {
        var _review_customerImage;
        return review === null || review === void 0 ? void 0 : (_review_customerImage = review.customerImage) === null || _review_customerImage === void 0 ? void 0 : _review_customerImage.src;
    };
    var hasCompanyLogo = function(review) {
        var _review_companyLogo;
        return review === null || review === void 0 ? void 0 : (_review_companyLogo = review.companyLogo) === null || _review_companyLogo === void 0 ? void 0 : _review_companyLogo.src;
    };
    var hasAtLeastOneImage = (0,react.useMemo)(function() {
        return reviews === null || reviews === void 0 ? void 0 : reviews.reduce(function(result, review) {
            return result || hasCustomerImage(review);
        }, false);
    }, [
        reviews
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReviewsCarousel, {
        className: "reviews-carousel",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("reviews-carousel-content-and-indicators", {
                    "has-customer-image": hasAtLeastOneImage
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "reviews-carousel-content",
                        children: reviews.map(function(review, index) {
                            var _quote = review.quote, quote = _quote === void 0 ? "" : _quote, _name = review.name, name = _name === void 0 ? "" : _name, _jobDescription = review.jobDescription, jobDescription = _jobDescription === void 0 ? "" : _jobDescription, companyLogo = review.companyLogo;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("quote-wrapper", {
                                    selected: index === currentReviewIndex
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                            className: "quote",
                                            id: "quote-".concat(index),
                                            children: [
                                                !removeQuoteSigns && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "quotationMark",
                                                    children: "“"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "quoteText",
                                                    children: "".concat(removeQuoteSigns ? quote : "".concat(quote, "”"))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "footer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "name-and-job-description",
                                                    id: "reviewer-".concat(index, "-name-and-job-description"),
                                                    children: "".concat(name, " | ").concat(jobDescription)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("logo", {
                                                        hidden: !hasCompanyLogo(review)
                                                    }),
                                                    children: hasCompanyLogo(review) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, reviews_carousel_object_spread_props(reviews_carousel_object_spread({}, companyLogo), {
                                                        height: "38px"
                                                    }))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "indicators",
                        children: reviews.map(function(review, indicatorIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: INDICATOR_WRAPPER_CLASS_NAME,
                                onClick: function(e) {
                                    return selectReview(indicatorIndex, e);
                                },
                                onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(function() {
                                    return selectReview(indicatorIndex);
                                }),
                                "aria-label": "review".concat(indicatorIndex + 1),
                                "aria-describedby": "reviewer-".concat(indicatorIndex, "-name-and-job-description quote-").concat(indicatorIndex),
                                "aria-current": indicatorIndex === currentReviewIndex,
                                role: "button",
                                tabIndex: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("indicator", {
                                        selected: indicatorIndex === currentReviewIndex
                                    })
                                })
                            }, indicatorIndex);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("reviews-carousel-asset", {
                    hidden: !hasCustomerImage(reviews === null || reviews === void 0 ? void 0 : reviews[currentReviewIndex])
                }),
                children: hasCustomerImage(reviews === null || reviews === void 0 ? void 0 : reviews[currentReviewIndex]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, reviews_carousel_object_spread({}, reviews === null || reviews === void 0 ? void 0 : (_reviews_currentReviewIndex = reviews[currentReviewIndex]) === null || _reviews_currentReviewIndex === void 0 ? void 0 : _reviews_currentReviewIndex.customerImage))
            })
        ]
    });
};
/* harmony default export */ var reviews_carousel = (ReviewsCarousel);
ReviewsCarousel.defaultProps = default_props;

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var full_paragraph_default_props = __webpack_require__(7484);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var paragraph_and_carousel_reviews_default_props = ({
    titleSize: sizes.XL,
    alignToLogo: true,
    fullParagraph: default_props_object_spread_props(default_props_object_spread({}, full_paragraph_default_props/* default */.Z), {
        topic: "",
        title: "<light>Hear<br>it from our<br></light><b>customers</b>",
        body: "Real people, real reviews"
    }),
    carousel: default_props_object_spread({}, default_props),
    mobileMarginBetweenParagraphAndCarousel: "32px"
});

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-component.scss.js


var StyledParagraphAndCarouselReviewsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eatr2t10"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.side-by-side-text-and-asset-component{.side-by-side-content{.full-paragraph-component-wrapper{padding-bottom:100px;}}}.image-wrapper{filter:drop-shadow(-16px 23px 56px rgba(29,140,242,0.3));}");

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.js + 1 modules
var full_paragraph_component = __webpack_require__(98461);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel_carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-mobile-component/paragraph-and-carousel-reviews-mobile-component.scss.js



var IMAGE_SIZE = 113;
var StyledParagraphAndCarouselReviewsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ymfqjh0"
})(".carousel-wrapper{margin-top:var(--margin-between-paragraph-and-carousel);.review-carousel-item{padding:0 20px;display:flex;flex-direction:column;align-items:center;.customer-image-wrapper{display:flex;align-items:center;position:absolute;justify-content:center;.customer-image{width:", IMAGE_SIZE, "px;border-radius:", IMAGE_SIZE / 2, "px;}}.review-card{color:white;margin-top:", IMAGE_SIZE * 2 / 5, "px;padding:", IMAGE_SIZE * 4 / 5, "px 12px 0 12px;background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border-radius:8px;text-align:center;.name-and-job-description{font-size:0.875rem;font-weight:500;min-height:64px;}.quote{font-size:0.8125rem;padding:16px 0;min-height:112px;}.company-logo-wrapper{padding:0 0 24px;display:flex;justify-content:center;align-items:flex-end;min-height:96px;.company-logo{width:92px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-mobile-component/paragraph-and-carousel-reviews-mobile-component.js
function paragraph_and_carousel_reviews_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_carousel_reviews_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_carousel_reviews_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var ParagraphAndCarouselReviewsMobileComponent = function(props) {
    var carousel = props.carousel, fullParagraph = props.fullParagraph, mobileMarginBetweenParagraphAndCarousel = props.mobileMarginBetweenParagraphAndCarousel, removeQuoteSigns = props.removeQuoteSigns;
    var reviews = carousel.reviews;
    var itemRenderer = function(review) {
        var customerImage = review.customerImage, name = review.name, jobDescription = review.jobDescription, quote = review.quote, companyLogo = review.companyLogo;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "review-carousel-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "customer-image-wrapper",
                    children: (customerImage === null || customerImage === void 0 ? void 0 : customerImage.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        className: "customer-image",
                        src: customerImage === null || customerImage === void 0 ? void 0 : customerImage.src,
                        alt: customerImage === null || customerImage === void 0 ? void 0 : customerImage.alt
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "review-card",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "name-and-job-description",
                            children: [
                                name,
                                " | ",
                                jobDescription
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "quote",
                            children: removeQuoteSigns ? quote : "“".concat(quote, "“")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "company-logo-wrapper",
                            children: (companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                className: "company-logo",
                                src: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.src,
                                alt: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.alt
                            })
                        })
                    ]
                })
            ]
        });
    };
    var carouselProps = {
        items: reviews,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        autoplaySpeed: 5000,
        centerPadding: "15%"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphAndCarouselReviewsMobileComponent, {
        className: "paragraph-and-carousel-reviews-mobile-component",
        style: {
            "--margin-between-paragraph-and-carousel": mobileMarginBetweenParagraphAndCarousel
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph_component["default"], paragraph_and_carousel_reviews_mobile_component_object_spread({}, fullParagraph)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_carousel/* default */.Z, paragraph_and_carousel_reviews_mobile_component_object_spread({}, carouselProps))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-component.js
function paragraph_and_carousel_reviews_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_carousel_reviews_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_carousel_reviews_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function paragraph_and_carousel_reviews_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        paragraph_and_carousel_reviews_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var ParagraphAndCarouselReviewsDesktopComponent = function(props) {
    var carousel = props.carousel, removeQuoteSigns = props.removeQuoteSigns, rest = _object_without_properties(props, [
        "carousel",
        "removeQuoteSigns"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParagraphAndCarouselReviewsDesktopComponent, {
        className: "paragraph-and-carousel-reviews-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(two_thirds_text_and_asset_component["default"], paragraph_and_carousel_reviews_component_object_spread_props(paragraph_and_carousel_reviews_component_object_spread({}, rest), {
            replaceAssetComponent: reviews_carousel,
            replaceAssetComponentProps: paragraph_and_carousel_reviews_component_object_spread_props(paragraph_and_carousel_reviews_component_object_spread({}, carousel), {
                removeQuoteSigns: removeQuoteSigns
            })
        }))
    });
};
var ParagraphAndCarouselReviewsComponent = (0,responsive_hoc_component/* default */.Z)(ParagraphAndCarouselReviewsDesktopComponent, ParagraphAndCarouselReviewsMobileComponent);
ParagraphAndCarouselReviewsComponent.defaultProps = paragraph_and_carousel_reviews_default_props;
/* harmony default export */ var paragraph_and_carousel_reviews_component = (ParagraphAndCarouselReviewsComponent);


/***/ }),

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38305);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    fullParagraph: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].fullParagraph */ .Z.fullParagraph), {
        topic: {
            text: "For the creative process",
            color: "brand-blue"
        },
        title: "Streamline your creative workflow",
        body: "Use customizable forms to request all the information needed. Then, easily share assets and receive feedback in real time."
    }),
    asset: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset */ .Z.asset), {
        image: _object_spread_props(_object_spread({}, segments_desktop_text_and_asset_layouts_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"].asset.image */ .Z.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
        })
    })
}));


/***/ }),

/***/ 32968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TwoThirdsTextAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.scss.js

var StyledTwoThirdsTextAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emxkgw60"
})(".side-by-side-text-and-asset-component{.side-by-side-content{.full-paragraph-component-wrapper{width:40%;}.image-wrapper{width:60%;}&.no-text-component{justify-content:center;.image-wrapper{width:100%;}}}}");

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props.js
var default_props = __webpack_require__(427);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var TwoThirdsTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoThirdsTextAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoThirdsTextAndAssetComponent);
    function TwoThirdsTextAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, TwoThirdsTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoThirdsTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoThirdsTextAndAssetComponent, {
                    className: "two-thirds-text-and-asset-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], _object_spread({}, this.props))
                });
            }
        }
    ]);
    return TwoThirdsTextAndAssetComponent;
}(react.PureComponent);

TwoThirdsTextAndAssetComponent.defaultProps = default_props/* default */.Z;


/***/ })

}]);